<template>
    <div>
        <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between">
            <h4 class="font-weight-bold">Documentação</h4>
        </div>
        <load mode="table" v-if="loading" />
        <form v-else @submit.prevent="cadastarDocumentacao" ref="addItem">
            <div class="row">
                <form-select
                    v-model="documentacao"
                    :itens="$root.arrays.acolhimento_documentacao_idoso"
                    label="Qual Documentação?"
                    grid="6"
                    :required="true"
                />
                <form-select
                    v-model="acao"
                    :required="true"
                    :itens="$root.arrays.acolhimento_documentacao_acao"
                    label="Ação?"
                    grid="6"
                />
            </div>
            <div class="row">
                <form-input
                    label="Detalhe da documentação"
                    v-model="detalhe_documentacao"
                    v-show="mostrarDetalheDocumentacao"
                    :required="mostrarDetalheDocumentacao"
                    maxlength="100"
                />
            </div>
            <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end align-items-center gap-3">
                <form-toggle
                    v-if="isIdoso" 
                    grid="2"
                    class="m-0"
                    mt="0"
                    v-model="privado"
                    label="Sigilo?"
                />
                <button
                    class="btn btn-primary m-0 px-4"
                    data-style="zoom-in"
                    type="submit"
                >
                    Cadastrar
                </button>
            </div>
        </form>
        <div class="row">
            <h3 class="px-3">Listagem de documentos</h3>

            <div class="col-12" v-if="item.documentacao.length > 0">
                <table class="table table-sm border align-middle">
                    <tbody>
                        <tr
                            v-for="(documento, index) in item.documentacao"
                            :key="documento.id"
                        >
                            
                            <td scope="col">
                                {{
                                    mascararValor(
                                        verificarValueArray(
                                            documento.documento,
                                            $root.arrays.acolhimento_documentacao_idoso
                                        ),
                                        documento.privado == 1,
                                        documento
                                    )
                                }}
                            </td>

                            <td scope="col">
                                {{
                                    mascararValor(
                                        verificarValueArray(
                                            documento.acao,
                                            $root.arrays.acolhimento_documentacao_acao
                                        ),
                                        documento.privado == 1,
                                        documento
                                    )
                                }}
                            </td>

                            <td scope="col" class="text-end">
                                <!-- Mostra botão de exclusão se não for privado OU se for o documento liberado -->
                                <button
                                    v-if="documento.privado != 1 || documento.id === documentoLiberadoId"
                                    title="Excluir documento"
                                    @click="excluirDocumento(documento.id, index)"
                                    class="btn px-2 mb-0 btn-danger btn-xs"
                                >
                                    <i class="mdi mdi-close"></i>
                                </button>

                                <!-- Mostra o olho se for privado e ainda não liberado -->
                                <button
                                    v-else
                                    title="Documento sigiloso"
                                    @click="visualizarDocumento(documento)"
                                    class="btn px-2 mb-0 btn-secondary btn-xs"
                                >
                                    <i class="mdi mdi-eye-outline"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-12" v-else>
                <h4 class="text-secondary">
                    <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                    Nada salvo aqui.
                </h4>
            </div>
        </div>

        <ModalVerificarPrivado
            v-if="exibirModalPrivado"
            @liberar="liberarDocumentoPrivado"
            @close="fecharModalPrivado"
        />

    </div>
</template>
<script>

import ModalVerificarPrivado from "../../includes/ModalVerificarPrivado";

export default {
    components: { ModalVerificarPrivado },
    props: ["item"],
    data() {
        return {
            documentacao: "",
            acao: "",
            detalhe_documentacao: "",
            loading: false,
            privado: "",
            documentoLiberadoId: null,
            exibirModalPrivado: false,
        };
    },
    watch: {
        'documentacao'(novoValor) {
            if (novoValor !== 13) {
                this.detalhe_documentacao = null; // ou "" se preferir string vazia
            }
        }
    },
    computed: {
        mostrarDetalheDocumentacao() {
            return this.documentacao === 13;
        },
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
    },
    methods: {
        mascararValor(valor, privado, documento) {
            if (privado && documento.id !== this.documentoLiberadoId) {
                return '*'.repeat(valor?.length || 4); // 4 por default se valor não existir
            }
            return valor;
        },
        visualizarDocumento(documento) {
            this.documentoSelecionado = documento; // guarda o documento atual
            this.exibirModalPrivado = true; // abre o modal
        },
        liberarDocumentoPrivado() {
            this.documentoLiberadoId = this.documentoSelecionado.id;
            this.exibirModalPrivado = false; // fecha o modal
        },
        fecharModalPrivado() {
            this.exibirModalPrivado = false;
        },
        submit() {
            this.$emit("submit");
        },
        cadastarDocumentacao() {
            this.loading = true;
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(
                    `api/dashboard/acolhimento/idoso/storedocumentacao`,
                    {
                        detalhe_documentacao: this.detalhe_documentacao,
                        documento: this.documentacao,
                        acao: this.acao,
                        acolhimento_id: this.item.id,
                        privado: this.privado
                    },
                    {
                        header: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: event => {
                            let progress = Math.round(
                                (event.loaded * 100) / event.total
                            );
                            this.progressCompleted = progress;
                        }
                    }
                )
                .then(response => {
                    ladda.stop();

                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                })
                .finally(() => {
                    this.documentacao = "";
                    this.acao = "";
                    this.loading = false;
                    this.privado = "";
                });
        },
        excluirDocumento(id) {
            swal.fire({
                text: "Aguarde a ação ser finalizada.",
                icon: "warning",
                showConfirmButton: false,
                timer: 1500
            });
            axios
                .get(
                    `api/dashboard/acolhimento/idoso/documentacao/excluir/${id}`
                )
                .then(response => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                });
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }

                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        }
    }
};
</script>
